import { cryptoCurrencySchema } from '@0xtorch/core'
import { z } from 'zod'
import { addressPrimitiveSchema, bigintTextSchema } from './primitive'

export const erc20TokenSchema = z.object({
  address: addressPrimitiveSchema,
  name: z.string(),
  symbol: z.string(),
  decimals: z.number().int(),
  currency: cryptoCurrencySchema,
})

export const erc20TransferSchema = z.object({
  address: addressPrimitiveSchema,
  from: addressPrimitiveSchema,
  logIndex: z.number().int(),
  to: addressPrimitiveSchema,
  value: bigintTextSchema,
})

export const erc20TokenTransferSchema = erc20TransferSchema.extend({
  token: erc20TokenSchema,
})

export type Erc20Token = z.infer<typeof erc20TokenSchema>

export type Erc20Transfer = z.infer<typeof erc20TransferSchema>

export type Erc20TokenTransfer = z.infer<typeof erc20TokenTransferSchema>
